import React from 'react';
import { GoogleMapLoader, GoogleMap, Marker } from 'react-google-maps';

export default (props) => {
    return (
        <GoogleMapLoader
            containerElement={ <div style={{height: '100%'}} /> }
            googleMapElement={
                <GoogleMap defaultZoom={16} defaultCenter={{lat: props.lat, lng: props.long}}>
                    <Marker {...props.marker}/>
                </GoogleMap>
            }
        />
    );
}


// WEBPACK FOOTER //
// ./src/components/google_map.js